import ImageSvg from "../ui/image-svg";

export const AprimoramosSection = () => {
  return (
    <section className="py-10 md:py-20">
      <div className="container">
        <div className="grid md:grid-cols-2 md:gap-16 gap-4 items-center">
          <div className="flex items-center justify-center ">
            <ImageSvg
              src="constante-aprimoramento.svg"
              alt="Constante aprimoramento"
              className="w-[70%] h-auto"
            />
          </div>
          <div>
            <h2 className="mb-5 text-n-text-green text-3xl font-semibold md:mb-6 md:text-4xl lg:text-5xl">
              Constante aprimoramento
            </h2>
            <p className="md:text-lg text-n-text-neutral mb-6">
              Ao longo de 15 anos, aprendemos com as experiências, desenvolvemos
              nossa cultura, parcerias, metodologias e tecnologias, além de
              estar em constante evolução para proporcionar a melhor experiência
              para o consumidor do serviço de transporte de veículos.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
